import React, { Component } from 'react'
import Select from "react-select";
import "react-select/dist/react-select.css";
import { FormGroup, ControlLabel } from 'react-bootstrap'

import { connect } from 'react-redux';

import { NONE, RESERVE, COMPLETE_QUOTA } from 'constants/draftSaleOrderPaymentTypeConst';

class FirstQuotaAndReserveSelect extends Component {

    constructor(props) {
        super(props);
    }

    handleOnChange(paymentType) {
        if (paymentType == undefined || paymentType == null) {
            paymentType = {
                value: NONE
            }
        }
        this.props.updateDraftSaleOrderPaymentType(paymentType.value);
    }

    render() {
        let paymentTypeOptions = [
            {
                label: "Seleccionar pago",
                value: NONE
            },
            {
                label: "Cuota Completa",
                value: COMPLETE_QUOTA
            },
            {
                label: "Reserva",
                value: RESERVE
            }
        ]
        return (
            <FormGroup controlId="formControlsSelect">
                <ControlLabel>Pago: </ControlLabel>
                <Select
                    placeholder="Seleccionar tipo de Pago"
                    name="singleSelect"
                    value={this.props.paymentType}
                    options={paymentTypeOptions}
                    onChange={value => this.handleOnChange(value)}
                />
            </FormGroup>
        )
    }
}

const mapStateToProps = state => ({

});
export default connect(mapStateToProps, {})(FirstQuotaAndReserveSelect);


// WEBPACK FOOTER //
// ./src/components/FirstQuotaAndReserveSelect/FirstQuotaAndReserveSelect.jsx